module.exports = __webpack_public_path__ + "img/logo3.a49eddcb.png";